import store from '..'
import axios from 'axios'
import router from '@/router'
import API from '@/common/api'

// google web font
axios.get('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyD87kW7jzc3vPCMPA6SFTOglRHYvOb6D_o&sort=popularity')
  .then(res => res.data.items)
  .then(items => {
    const fonts = items.splice(0, 100)
    const fontFamily = fonts.map(x => x.family.replace(/ /gi, '+')).join('|')
    const webfont = document.createElement('link')
    webfont.type = 'text/css'
    webfont.async = true
    webfont.rel = 'StyleSheet'
    webfont.href = `//fonts.googleapis.com/css?family=${fontFamily}`
    document.head.appendChild(webfont)
  })
  .catch((ex) => {
    console.error('error:', ex)
  })

export default {
  namespaced: true,
  state: {
    lang: {},
    setting: {},
    menu: {},
    floating: {},
    dgb: null,
    guestType: {}
  },
  mutations: {
    setMeta (state) {
      const title = state.setting.title[state.lang.current]
      document.title = title
    },
    setMetaScale (state, isScalable) {
      const scalable = isScalable ? 'user-scalable=yes' : 'user-scalable=no'
      const content = `width=device-width,initial-scale=1.0,${scalable}`
      document.querySelector('meta[name="viewport"]').setAttribute('content', content)
    },
    langObj (state, data) {
      const obj = {}
      state.setting.lang.info.forEach(function (x) {
        obj[x.c] = data || ''
      })
      return obj
    }
  },
  actions: {
    setDocsLang ({ state }, lang) {
      document.getElementsByTagName('html')[0].setAttribute('lang', lang)
      const setLang = setInterval(() => {
        if (document.getElementsByTagName('html')[0].getAttribute('lang') !== lang) {
          document.getElementsByTagName('html')[0].setAttribute('lang', lang)
        } else {
          clearInterval(setLang)
        }
      }, 100)
    },
    async getGuestTypes ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-manage',
          func: 'get-guest-types',
          id: `a.${store.state.authentication.site}`
        })
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    async loadSetting ({ dispatch }) {
      const file = 'setting/setting.json'
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        dispatch('setCommon', res.data.message)
        return res.data.message
      } catch (ex) {
        console.log(ex)
        console.log(ex && ex.response)
        if (ex && ex.response && ex.response.data && ex.response.data.message && ex.response.data.message.includes('No file found')) {
          alert('The setup information could not be found.')
        } else {
          alert('Invalid access has been detected.')
        }

        router.replace({
          name: 'error',
          params: {
            reason: 'setting'
          }
        })
      }
    },
    async getSiteinfo ({ state }) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-site-info&siteid=${API.SITE_INFO.site}`)
        store.state.siteInfo = res.data.message
        return res.data.message
      } catch (ex) {
        state.dgb = null
        return false
      }
    },
    async getDgb ({ state }) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-dgb-siteid&siteid=${API.SITE_INFO.site}`)
        return res.data.message
      } catch (ex) {
        state.dgb = null
        return false
      }
    },
    async loadDgbData ({ state }, dgbData) {
      const file = `setting/setting.json`
      if (dgbData.name !== 'localinfo') {
        try {
          const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${dgbData.name}&file=${file}`)
          return res.data.message.main.page
        } catch (ex) {
          return null
        }
      }
    },
    getDgbData ({ state, dispatch }) {
      return dispatch('getDgb').then((res) => {
        if (res) {
          state.dgb = res
          dispatch('loadDgbData', res).then((res) => {
            state.dgb.page = res
          })
        } else {
          return false
        }
      })
    },
    async loadMenu ({ dispatch }, menuId) {
      const file = `menu/item/${menuId}.json`
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        dispatch('setMenu', res.data.message)
        return res.data.message
      } catch (ex) {
        // console.log(ex.response)
        if (ex.response.data.message.includes('No file found')) {
          alert('The setup information could not be found.')
        } else {
          alert('Invalid access has been detected.')
        }
        router.replace({ path: '/notfound' })
      }
    },
    async loadFloating ({ state, dispatch }) {
      const file = 'floating/floating.json'
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        state.floating = res.data.message
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    setCommon ({ state, commit, dispatch }, data) {
      state.setting = data
      state.lang = {
        default: data.lang.default,
        current: data.lang.default
      }
      // set added font list
      const setAddedFont = function (addedFonts) {
        addedFonts.forEach(function (font) {
          const fontFamilyId = `font_${font.family.trim()}`
          if (document.head.getElementsByClassName(fontFamilyId).length === 0) {
            const fontface = document.createElement('style')
            const createFontFace = document.createTextNode(`
              @font-face{
                font-family: ${font.family};
                src: url(${font.uri});
              }
            `)
            fontface.setAttribute('class', fontFamilyId)
            fontface.appendChild(createFontFace)
            document.head.appendChild(fontface)
          }
        })
      }
      commit('setMeta')
      setAddedFont(data.font.added)
      // document.body.style.fontFamily = `${data.font.default}, "Noto Sans", "Kosugi Maru", "Noto Sans SC", "Noto Sans KR", "sans-serif"`
      const css = `body {
        font-family: ${data.font.default}, "Noto Sans", "Kosugi Maru", "Noto Sans SC", "Noto Sans KR", "sans-serif"
      }`
      const head = document.head || document.getElementsByTagName('head')[0]
      const style = document.createElement('style')
      head.appendChild(style)
      style.type = 'text/css'
      if (style.styleSheet) {
        style.styleSheet.cssText = css
      } else {
        style.appendChild(document.createTextNode(css))
      }
      if (data.order && data.order.taxActive && data.order.tax.length > 0) {
        const tax = {
          key: 'tax',
          value: Number(data.order.tax)
        }
        store.commit('payment/setTaxTip', tax, { root: true })
      }
      if (data.order && data.order.tipActive) {
        const tip = {
          key: 'tip',
          value: [...data.order.tip, 'custom', 'notip'],
          includesTax: data.order.tipIncludeTax
        }
        store.commit('payment/setTaxTip', tip, { root: true })
      }
    },
    setMenu ({ state }, data) {
      state.menu.sns = data.snsList
      const filteredData = function (tree) {
        tree.forEach(function (x) {
          delete x.state
          delete x.text
          delete x.data.text
          if (x.children && x.children.length) {
            filteredData(x.children)
          }
        })
        return tree
      }
      const list = filteredData(data.tree)
      state.menu.list = list
    },
    setLang ({ state, commit, dispatch }, data) {
      const wasAuto = store.state.translate === 'auto'
      const isManual = state.setting.lang.manual && state.setting.lang.manual.includes(data)
      store.commit('translateRestore', isManual)
      setTimeout(() => {
        state.lang.current = data
        commit('setMeta')
        router.replace({ params: { ln: data } })
      }, wasAuto && isManual ? 500 : 0) // 자동번역에서 직접번역으로 바뀔때는 구글번역을 먼저 꺼야함
    }
  },
  getters: {
    getSetting: state => {
      return state.setting
    },
    getMenu: state => {
      return state.menu
    },
    getDateFormat (state) {
      if (typeof (state.setting.dateFormat) !== 'undefined') {
        return state.setting.dateFormat[state.setting.dateformatDefault]
      }
    },
    getTitle (state) {
      return state.setting.title[state.lang.current]
    },
    getLang (state) {
      return state.lang.current
    },
    getFloating: state => state.floating,
    getPointColors: state => (target, attr) => {
      const style = {}
      const value = state.setting && state.setting.pointcolors && state.setting.pointcolors[target]
      style[attr] = value
      return attr && value ? style : null
    },
    getPointColorsMultiple: state => (arr) => {
      const style = {}
      for (let i = 0; i < arr.length; i++) {
        const st = arr[i]
        const target = st.target
        const attr = st.attr
        const value = state.setting && state.setting.pointcolors && state.setting.pointcolors[target]
        if (target && attr && value) {
          style[attr] = value
        }
      }
      return arr && arr.length > 0 ? style : null
    },
    getUserinfo: state => {
      const order = state.setting.order
      const custom = Object.keys(order).filter(x => x.startsWith('custom') && order[x].active).map(x => order[x])
      return {
        firstName: order && order.firstName === false ? order.firstName : true,
        lastName: order && order.lastName === false ? order.lastName : true,
        tel: order ? order.tel : true,
        email: order ? order.email : false,
        ...custom && {
          custom: custom
        }
      }
    }
  }
}
